import { BriefQueryChannelEnum } from "@api/TrackerApi";
import { proxy } from "valtio";

/**
 * ad_source 内存 store（不持久化）。
 * 用途：登录接口上报给后端（后端字段名待确认后接入）。
 * 与 cookie（edgen_ad_source，供 proxy/EntryGate 路由用）并行存在：
 *   - cookie：持久、服务端可读（路由门禁）
 *   - 本 store：内存、不持久化、仅本次会话（登录上报）
 * 写入点：深链捕获 + 登录后 ownerInfo.ad_source 覆盖（与 cookie 同步写）。
 */
const adSourceStore = proxy<{
  adSource: string | null;
  querySource: string | null;
}>({
  adSource: null,
  querySource: null,
});

export function setAdSourceInStore(value: string | null | undefined): void {
  const trimmed = value?.trim();
  adSourceStore.adSource = trimmed ? trimmed.toUpperCase() : null;
}

export function getAdSourceFromStore(): BriefQueryChannelEnum | null {
  return adSourceStore.adSource?.toUpperCase?.() as BriefQueryChannelEnum;
}

/** query_source（兴趣分类广告来源）：仅内存 store，不持久化、不存 cookie */
export function setQuerySourceInStore(value: string | null | undefined): void {
  const trimmed = value?.trim();
  adSourceStore.querySource = trimmed ? trimmed : null;
}

export function getQuerySourceFromStore(): string | null {
  return adSourceStore.querySource;
}
